namespace('compass.demographic');

compass.demographic.FrequentGuestNumberWidget = compass.defineWidget(function FrequentGuestNumberWidget(options) {
	var me = this;
	var $j = jQuery;
	var _d = jQuery.dom.getContext(this);

	var _settings = options;
	var _validator = options.validator;

	var _label = {
		label: 'Hotel Rewards Number',
		hint: 'Number must be less than 30 characters'
	};

	var _grabValues = this.grabValues = function() {
		return $j('.frequentGuestNumberInput').val();
	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		var _labelId = compass.generateId();
		var _alertId = compass.generateId();
		var infoButton = d.div({},
			_label.label,
			d.span({
				className : 'fgnInfoImg',
				role : 'button',
				'ARIA-role' : 'button',
				'ARIA-labelledby' : _labelId,
				'ARIA-owns' : _alertId,
				tabindex : 0
			}).activate(function() {
				d.alert({
					id: _alertId,
					message: 'Earn loyalty rewards points and maintain your status level with your preferred hotel brand—simply enter your rewards number when booking.',
					includeImage: false
				});
			})
		);

		var input = d.input({
			type : 'text',
			name : 'frequentGuestNumber',
			className : 'frequentGuestNumber frequentGuestNumberInput',
			'tabindex': '0',
			id: compass.generateId(),
			autocomplete: 'off',
			'data-parsley-error-message': _label.hint, 
			'data-parsley-maxlength': 30
		}).val(_settings.frequentGuestNumber ? _settings.frequentGuestNumber : "")
		.data('hint', _label.hint)
		.change(function() {
			me.trigger('FrequentGuestNumberWidget.guestNumberChanged');
		});
		var field = d.fieldLabelPair({
			className : 'frequentGuestNumber',
			label : infoButton
		}, [input]);
		widgetElem.append(field);

		// validate fields
		if (_validator) {
			_validator.addFields([input], function(input) {
				return input.val().length <= 30 ? _validator.VALID : _validator.INVALID;
			});
		}
	};

}, {
	WUID : 'CRAP',
	widgetName : 'FrequentGuestNumberWidget',
	frequentGuestNumber: null
});
